import { State } from "../types/store";

export const selectAuth = (state: State) => state.auth;
export const selectAuthUserType = (state: State) => state.auth.userType;
export const selectAuthLoading = (state: State) => state.auth.isLoading;
export const selectAuthUser = (state: State) => state.auth.user;
export const selectAuthErrors = (state: State) => state.auth.errors;
